// Holder imperativo de la empresa activa, leído por el cliente API para inyectar
// el header X-Active-Company. Lo escribe ActiveCompanyProvider tras cargar /me.
// Es un singleton de módulo (no estado de React) porque el cliente API se crea
// fuera del árbol que resuelve la empresa activa (evita el ciclo /me ↔ contexto).

let activeCompanyId: string | null = null;

export function getActiveCompanyId(): string | null {
  return activeCompanyId;
}

export function setActiveCompanyId(id: string | null): void {
  activeCompanyId = id;
}

// Empresa elegida por el usuario, recordada en el navegador (comodidad por persona,
// no fuente de verdad: el provider la valida contra sus empresas en cada carga).
// El almacenamiento puede no estar disponible (modo privado, bloqueado): nunca rompe.
function storageKey(authSubject: string): string {
  return `qms.activeCompany:${authSubject}`;
}

export function readStoredCompany(authSubject: string): string | null {
  try {
    return localStorage.getItem(storageKey(authSubject));
  } catch {
    return null;
  }
}

export function storeCompany(authSubject: string, companyId: string | null): void {
  try {
    if (companyId === null) {
      localStorage.removeItem(storageKey(authSubject));
    } else {
      localStorage.setItem(storageKey(authSubject), companyId);
    }
  } catch {
    // Sin almacenamiento la elección vale solo para esta sesión.
  }
}
